import type { ReactNode } from "react";

export type FilterBarCount = { shown: number; total?: number; unit?: string };

export type FilterBarProps = {
  /** 検索の欄 (上の行の左) */
  search?: ReactNode;
  /** 並べ替えの選択 (上の行) */
  sort?: ReactNode;
  /** 絞り込みの札の並び (FilterChips) や選択。下の行に並ぶ */
  groups?: ReactNode;
  /** 下の行の最後に足すもの (「テスト用も表示」のチェックなど) */
  extra?: ReactNode;
  /** 条件を戻す操作。絞り込んでいるときだけ渡す */
  reset?: ReactNode;
  /** 結果の件数。変わると読み上げで知らされる */
  count?: FilterBarCount;
  /** 件数を数え直している間 */
  loading?: boolean;
  /** 棒の名前 (読み上げ) */
  label?: string;
  className?: string;
};

function countText(count: FilterBarCount, loading: boolean): string {
  if (loading) return "数えています";
  const unit = count.unit ?? "件";
  return count.total !== undefined && count.total !== count.shown ? `${count.total} ${unit}中 ${count.shown} ${unit}` : `${count.shown} ${unit}`;
}

/**
 * 絞り込みの棒。検索、並べ替え、件数の行と、絞り込みの札の行を 1 つの形にする。
 * 検索も並べ替えも無いときは件数だけの行を作らず、札の行の右端に件数を置く
 */
export function FilterBar({ search, sort, groups, extra, reset, count, loading = false, label = "絞り込み", className }: FilterBarProps) {
  const showGroups = Boolean(groups) || Boolean(extra) || Boolean(reset);
  const countWithGroups = !search && !sort && showGroups;
  const countLine = count ? (
    <p className="lg-filter__count" role="status" aria-live="polite">
      {countText(count, loading)}
    </p>
  ) : null;
  return (
    <div role="search" aria-label={label} className={`lg-filter${className ? ` ${className}` : ""}`} aria-busy={loading ? true : undefined}>
      {countWithGroups ? null : (
        <div className="lg-filter__row">
          {search}
          {sort}
          {countLine}
        </div>
      )}
      {showGroups ? (
        <div className="lg-filter__row lg-filter__row--groups">
          {groups}
          {extra}
          {reset}
          {countWithGroups ? countLine : null}
        </div>
      ) : null}
    </div>
  );
}
